module.exports = __webpack_public_path__ + "static/media/ig.e0cf3fe6.svg";